import { GET_USER_START } from '../../types';

export const userdata = (payload) => ({
  type: GET_USER_START,
  payload,
});
